import { useQuery } from "@tanstack/react-query";
import { getClientsForSelect } from "../../api/apiClients";
import i18next from "i18next";

/**
 * Hook لجلب العملاء لاستخدامها في قوائم الاختيار (Select)
 * @param {Object} params - Query parameters
 */
export function useGetClientsForSelect(params = {}) {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ["clientsForSelect", params, i18next.language],
        queryFn: () => getClientsForSelect(params),
        retry: false,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
        refetch
    };
}